<template>
  <Layout>
    <!-- start page title -->
    <PageHeader :title="title" :items="items" />
    <!-- end page title -->

    <div class="row">
      <div class="col-12 col-sm-12 col-md-12 col-xl-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">General Checkers Queue</h4>
            <!-- Supposed Form -->
            <div class="form-body">
              <GeneralCheckersQueueTable />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>

<script>
/**
 * General Checkers Queue
 */
import Layout from "../../router/layouts/main";
import PageHeader from "../../components/AppComponents/page-header";
import GeneralCheckersQueueTable from "@/components/Kleyton/Tables/queue/GeneralCheckersQueueTable";

export default {
  name: "GeneralCheckersQueue",
  page: {
    title: "General Checkers Queue",
    meta: [{ name: "General Checkers Queue", content: window.__env.app.description }]
  },
  components: {
    GeneralCheckersQueueTable,
    Layout,
    PageHeader
  },
  data() {
    return {
      createBankFormBody: {
        source: "web"
      },
      title: "General Checkers Queue",

      items: [
        {
          text: "Queue",
          href: "/"
        },
        {
          text: "Queue",
          active: true
        }
      ]
    };
  },
  methods: {}
};
</script>
